export default "__VITE_ASSET__66a7cb2c__"